import { render, staticRenderFns } from "./OutOfAreaSchoolsView.vue?vue&type=template&id=f626ade4&scoped=true&"
import script from "./OutOfAreaSchoolsView.vue?vue&type=script&lang=js&"
export * from "./OutOfAreaSchoolsView.vue?vue&type=script&lang=js&"
import style0 from "./OutOfAreaSchoolsView.vue?vue&type=style&index=0&id=f626ade4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f626ade4",
  null
  
)

export default component.exports